export default "__VITE_ASSET__nuJauWmE__"